import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  font-size: 25px;
  font-weight: 500;
  color: #edeeef;
`;

interface CategoryHeaderNewProps {
  category: string;
}

const CategoryHeaderNew: React.FC<CategoryHeaderNewProps> = ({ category }) => {
  return <Container>{category}</Container>;
};

export default CategoryHeaderNew;
